<template>
    <div class="page__container center">
      <section class="not_found">
        <div class="not_found__numar">404</div>
        <h1>{{ $t("notFound.title") }}</h1>
        <p>{{ $t("notFound.message") }}</p>
     
        <MainButton :buttonText="$t('button.backToHome')" targetRoute="home" />


      </section>
     
    </div>
  </template>
  
  <script>
  import MainButton from "@/components/Buttons/MainButton.vue"; 
  
  export default {
    components: { MainButton },
    methods: {
      localizedRoute(name) {
        let locale = this.$i18n.locale || "en";
  

        const supportedLocales = ["en", "ru", "ro"];
        if (!supportedLocales.includes(locale)) {
          locale = "en"; 
          this.$router.replace(`/${locale}`); 
        }
  
        const localizedPath = this.$i18n.t(`url.${name}`);
        return localizedPath ? (name === "home" ? `/${locale}` : `/${locale}/${localizedPath}`) : `/${locale}`;
      }
    }
  };
  </script>
  

  